export default __webpack_public_path__ + "static/media/aboutimg.74720519.png";